import { jsx as e, jsxs as i, Fragment as I } from "react/jsx-runtime";
import { Popover as R, PopoverButton as z, Transition as A, PopoverPanel as M, FocusTrap as S, FocusTrapFeatures as $ } from "@headlessui/react";
import { useState as q, useRef as G, useEffect as H, Fragment as J } from "react";
import { HexAlphaColorPicker as K, HexColorPicker as Q, HexColorInput as U } from "react-colorful";
import { twMerge as t } from "tailwind-merge";
import { TooltipCustomButton as V } from "../tooltip/custom-button.mjs";
import { useDebouncedColorChange as W } from "./hooks/use-debounced-color-change.mjs";
import { FieldErrorAndDescription as X } from "../form/field-error-and-description.mjs";
const ae = ({
  color: x,
  labelClassName: h,
  popoverClassName: b,
  popoverButtonClassName: y,
  popoverButtonChildClassName: k,
  hexColorInput: C,
  wrapperClassName: E,
  children: c,
  additionalPopoverChildren: d,
  focusTrapFeatures: F = $.None,
  stayWhenUnfocused: N = !1,
  showAlpha: m = !0,
  showOnlyHue: n = !1,
  error: f,
  description: w,
  anchor: L = "top",
  disabled: T,
  onChange: P,
  ..._
}) => {
  const [j, l] = q(!1), a = G(null), { currentColor: u, updateColor: p, syncCurrentColor: B } = W({
    color: x,
    onChange: P
  });
  H(() => {
    const s = (o) => {
      var g;
      (g = a.current) != null && g.contains(o.target) && l(!0);
    }, r = (o) => {
      a.current && !a.current.contains(o.target) && l(!1);
    }, v = (o) => {
      o.key === "Escape" && l(!1);
    };
    return document.addEventListener("focusin", s), document.addEventListener("touchstart", r, !0), document.addEventListener("mousedown", r, !0), document.addEventListener("keydown", v), () => {
      document.removeEventListener("focusin", s), document.removeEventListener("touchstart", r, !0), document.removeEventListener("mousedown", r, !0), document.removeEventListener("keydown", v);
    };
  }, []);
  const D = m && !n ? K : Q;
  return /* @__PURE__ */ e(R, { className: "flex items-center", children: ({ open: s }) => {
    const r = N && j || s;
    return /* @__PURE__ */ i(I, { children: [
      /* @__PURE__ */ e(
        z,
        {
          disabled: T,
          as: V,
          className: t(
            "relative truncate outline-hidden",
            "cursor-pointer",
            "h-full w-full max-w-fit",
            "focus-ring rounded-lg",
            f && "border-danger rounded-xl border-2 p-0.5",
            y
          ),
          children: (c == null ? void 0 : c(r)) ?? /* @__PURE__ */ e(
            "div",
            {
              style: { backgroundColor: u },
              className: t(
                "border-text-secondary/30 h-10 w-10 rounded-lg border",
                k
              )
            }
          )
        }
      ),
      /* @__PURE__ */ e(
        A,
        {
          as: J,
          show: r,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ e(
            M,
            {
              ref: a,
              anchor: L,
              className: t(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                n ? "pt-4" : "pt-5",
                b
              ),
              children: /* @__PURE__ */ e(S, { features: F, children: /* @__PURE__ */ e(
                "div",
                {
                  className: t(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    "max-w-[200px]",
                    h
                  ),
                  children: /* @__PURE__ */ i(
                    "div",
                    {
                      className: t(
                        "flex flex-col gap-3",
                        n && "[&_.react-colorful]:!h-fit [&_div.react-colorful>div:first-child]:hidden [&_div.react-colorful>div:nth-of-type(2)]:!rounded-lg",
                        E
                      ),
                      children: [
                        /* @__PURE__ */ e(D, { color: u, onChange: p, ..._ }),
                        !n && /* @__PURE__ */ i("div", { className: "flex", children: [
                          /* @__PURE__ */ e("div", { className: "bg-background-tertiary rounded-l-lg p-2", children: "#" }),
                          /* @__PURE__ */ e(
                            U,
                            {
                              alpha: m,
                              className: t(
                                "main-transition-colors border-text-secondary/30 focus:border-brand-primary w-full rounded-r-lg border p-2 outline-hidden",
                                C
                              ),
                              color: u,
                              onChange: p
                            }
                          )
                        ] }),
                        d == null ? void 0 : d(B),
                        /* @__PURE__ */ e(
                          X,
                          {
                            errorClassName: "text-left",
                            error: f,
                            description: w
                          }
                        )
                      ]
                    }
                  )
                }
              ) })
            }
          )
        }
      )
    ] });
  } });
};
export {
  ae as ColorPicker
};
